export default __webpack_public_path__ + "static/tabs-hierarchy-do-f41386587c026b5050007a2a022e26bf.png";